import * as React from 'react';
import Typography from '@mui/material/Typography';
import { TabData } from '@/components/blocks/Tabs';
import { Box, Button, Stack } from '@mui/material';
import { useLocalization } from '@/data/Localization';

export const TabsDesktop: React.FC<{ tabs: TabData[], scrollToSection: (id: string) => void }> = ({ tabs, scrollToSection }) => {
    const localization = useLocalization('productDetail');
    return (
        <><Stack sx={{ borderBottom: '1px solid', width: '100%' }} direction="row" columnGap={6}>
            {tabs?.map((tab, i) =>
                <Button
                    onClick={() => scrollToSection(`description_title_${tab.id}`)}
                    variant='text'
                    key={i}
                    sx={{
                        p: 0,
                        '&:hover': { bgcolor: 'transparent' },
                        fontFamily: i===0 ? 'mikado-bold' : 'inherit',
                    }}
                >
                    {tab.title}
                </Button>
            )}
            <Button
                onClick={() => scrollToSection(`BVRR_Container`)}
                variant='text'
                sx={{
                    p: 0,
                    '&:hover': { bgcolor: 'transparent' }
                }}
            >{localization.Reviews.t()}</Button>
        </Stack>
            <Stack rowGap={5} sx={{ marginTop:'15px'}}>
                {tabs?.map((t, i) => {
                    return (
                        <Box key={i}>                          
                                <Typography
                                    component="h2"
                                    variant='body1AsH1'
                                    fontFamily='chaloops-bold'
                                    fontWeight={400}
                                    id={`description_title_${t.id}`}
                                >
                                    {t.title}
                                </Typography>
                            {t.content}
                        </Box>
                    );
                })}
            </Stack> </>
    );
}
